import { Injectable } from '@angular/core'
import { ApiService } from '@app/core/graphql/services/api.service'
import { PushMessageEventInput, Message } from '@app/models/message.model'
import { ServicesSubscriberEvent } from '@app/models/others.model'
import { GET_FILTERED_MESSAGES, SEND_PUSH_MESSAGE } from '@app/query/message.query'
import { TranslateMessagesService } from '@app/shared/services/translate-messages.service'
import { serializeAs } from '@app/utils/serialize'
import { pick } from 'lodash-es'
import { MessageService } from 'primeng/api'
import { map, Subject, tap } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class MessagesService {
  subscriber: Subject<ServicesSubscriberEvent> = new Subject<ServicesSubscriberEvent>()

  id: string = 'MESSAGES'
  sysMessage: any

  constructor(
    private API: ApiService,
    private translateMessagesService: TranslateMessagesService,
    private messageService: MessageService,
  ) {
    this.sysMessage = this.translateMessagesService.create(this.id)
  }

  getMessages(payload: any) {
    return this.API.privateQuery<any>(GET_FILTERED_MESSAGES, (data: any) => {
      const r = Object.assign(data, payload)
      return {
        data: r,
      }
    }).pipe(
      map((response: any) => {
        if (response.success) {
          return response.data as Message[]
        } else {
          return [] as Message[]
        }
      }),
      tap((events: Message[] | []) => {
        this.subscriber.next({
          type: `GET_${this.id}S`,
          data: events,
        })
      }),
    )
  }

  createNew(payload: Partial<PushMessageEventInput>) {
    return this.API.privateQuery<any>(SEND_PUSH_MESSAGE, (data: any) => {
      return {
        data: serializeAs(PushMessageEventInput, pick(Object.assign(payload, data), Object.keys(new PushMessageEventInput()))) as PushMessageEventInput,
      }
    }).pipe(
      tap((data: any) => {
        if (data.success) {
          this.messageService.add({
            severity: 'success',
            icon: 'pi pi-check-circle color-success',
            ...this.sysMessage.message('SEND_MESSAGE_SUCCESS'),
          })
          this.subscriber.next({
            type: `SET_${this.id}`,
            data: data.data as Message,
          })
        }
      }),
    )
  }
}
